const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const finderForm = document.querySelector(".finder");
    if (finderForm) finderForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const FINDER_LINKS = { "qubii-duo": "preview-qubii-duo-maktar.html", "qubii-ex": "preview-qubii-ex-maktar.html", "nukii": "preview-nukii-maktar.html", "bundles": "preview-bundles-maktar.html" };
      const device = (document.getElementById("f-device") || {}).value || "";
      const kind = (document.getElementById("f-type") || {}).value || "";
      let pick;
      if (/thumb/i.test(device)) pick = "nukii";        // encrypted thumb drive
      else if (/bundle/i.test(kind)) pick = "bundles";  // set with 5% off
      else if (/built/i.test(kind)) pick = "qubii-ex";  // storage built in
      else pick = "qubii-duo";                          // with or without card -> Duo (card option on page)
      const url = FINDER_LINKS[pick];
      if (url) { window.location.href = url; return; }
      const lineup = document.getElementById("lineup");
      if (lineup) lineup.scrollIntoView({ behavior: reduced ? "auto" : "smooth" });
    });

    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(window.ScrollTrigger);

      // Maktar wordmark: letters rise in one by one, then breathe gently
      const letters = gsap.utils.toArray(".hero__mark .ltr");
      gsap.set(letters, { transformOrigin: "50% 100%" });

      if (reduced) {
        // Tiered reduced-motion: gentle one-shot fade-ins only — no looping wave,
        // no parallax scrub, no auto-flip, no large movement.
        gsap.from(letters, { autoAlpha: 0, duration: 0.5, ease: "power1.out", stagger: 0.03 });
        [["[data-rise]", null], ["[data-row]", ".feat__list"], ["[data-stack-card]", ".stack__deck"], [".story__scene", ".story"]].forEach(function (p) {
          gsap.from(p[0], {
            autoAlpha: 0, duration: 0.6, ease: "power1.out", stagger: 0.05,
            immediateRender: false, clearProps: "opacity,visibility",
            scrollTrigger: p[1] ? { trigger: p[1], start: "top 92%", once: true } : undefined
          });
        });
      } else {
      const heroIntro = gsap.timeline({ delay: 0.15 });
      heroIntro.from(letters, { yPercent: 90, autoAlpha: 0, rotate: -9, duration: 1.0, ease: "back.out(1.7)", stagger: 0.07 });
      heroIntro.from("[data-rise]", { y: 22, autoAlpha: 0, duration: 0.8, ease: "power3.out", stagger: 0.1 }, "-=0.5");
      heroIntro.add(() => {
        // continuous wave so the wordmark is always visibly alive (not a one-shot)
        letters.forEach((l, i) => {
          gsap.to(l, { yPercent: -10, duration: 1.8, ease: "sine.inOut", repeat: -1, yoyo: true, delay: i * 0.16 });
        });
      });

      gsap.from("[data-row]", {
        y: 24, autoAlpha: 0, duration: 0.8, ease: "power3.out", stagger: 0.08,
        scrollTrigger: { trigger: ".feat__list", start: "top 80%", once: true }
      });

      // Lineup swipe stack: cards scale/fade into their fan poses once the section is
      // in view (no rotation here — the fan rotation is owned by the stack layout JS).
      // immediateRender:false + clearProps so a flaky scroll-trigger can never leave a
      // card stuck at a shrunken scale — worst case is no entrance but a correct fan.
      gsap.from("[data-stack-card]", {
        scale: 0.6, autoAlpha: 0,
        transformOrigin: "50% 50%", duration: 0.7, ease: "back.out(1.7)",
        stagger: { each: 0.07, from: "start" },
        immediateRender: false, clearProps: "opacity,visibility",
        scrollTrigger: { trigger: ".stack", start: "top 90%", once: true }
      });

      gsap.from(".story__scene", {
        autoAlpha: 0, y: 30, duration: 1, ease: "power3.out",
        immediateRender: false, clearProps: "opacity,visibility,transform",
        scrollTrigger: { trigger: ".story", start: "top 85%", once: true }
      });

      gsap.to(".ribbon--tilt .ribbon__track", {
        xPercent: -8,
        scrollTrigger: { trigger: ".ribbon--tilt", start: "top bottom", end: "bottom top", scrub: true }
      });
      }
    }

    /* Product hero image gallery — swap main image on thumbnail click */
    document.addEventListener("click", function (e) {
      var t = e.target.closest && e.target.closest(".pgallery__thumb");
      if (!t) return;
      var media = t.closest(".phero__media");
      var main = media && media.querySelector(".phero__stage img");
      var full = t.getAttribute("data-full");
      if (main && full) {
        main.setAttribute("src", full);
        if (media.hasAttribute("data-native-product-gallery")) {
          main.removeAttribute("srcset");
          main.removeAttribute("sizes");
          main.setAttribute("alt", t.getAttribute("data-image-alt") || "");
        }
      }
      var strip = t.parentElement;
      if (strip) strip.querySelectorAll(".pgallery__thumb").forEach(function (b) {
        b.classList.toggle("is-active", b === t);
        if (media.hasAttribute("data-native-product-gallery")) b.setAttribute("aria-pressed", b === t ? "true" : "false");
      });
    });

    /* Native Shopify forms: keep the displayed choice and submitted variant together. */
    (function () {
      var variantsByForm = new WeakMap();
      function variantsFor(form) {
        if (!variantsByForm.has(form)) {
          var data = form.querySelector("[data-variants]");
          var variants = [];
          try { variants = JSON.parse(data ? data.textContent : "[]"); } catch (error) {}
          variantsByForm.set(form, Array.isArray(variants) ? variants.filter(function (variant) {
            return variant && typeof variant === "object" &&
              typeof variant.id === "string" && /^[1-9]\d*$/.test(variant.id) &&
              Array.isArray(variant.options) && variant.options.length > 0 &&
              variant.options.every(function (option) { return typeof option === "string"; }) &&
              typeof variant.available === "boolean" &&
              typeof variant.price === "string" && variant.price.trim().length > 0;
          }) : []);
        }
        return variantsByForm.get(form);
      }
      function selectedVariant(form) {
        var groups = Array.from(form.querySelectorAll(".pspec__group"));
        var input = form.querySelector("[data-variant-id]");
        return variantsFor(form).find(function (variant) {
          if (!groups.length) return input && String(variant.id) === input.value;
          return Array.isArray(variant.options) && variant.options.length === groups.length && groups.every(function (group, index) {
            var selected = group.querySelector("[data-option-value].is-active");
            return selected && selected.getAttribute("data-option-value") === variant.options[index];
          });
        });
      }
      function update(form, changeUrl) {
        var variant = selectedVariant(form);
        var input = form.querySelector("[data-variant-id]");
        var add = form.querySelector("[data-add]");
        var text = form.querySelector("[data-add-text]");
        var price = form.querySelector("[data-price]");
        var available = !!(variant && variant.available);
        if (input) {
          input.value = variant ? String(variant.id) : "";
          input.disabled = !variant;
        }
        if (add) add.disabled = !available;
        if (text) text.textContent = form.getAttribute(variant ? (available ? "data-add-label" : "data-sold-out-label") : "data-unavailable-label");
        if (price) price.textContent = variant ? variant.price : "";

        var scope = form.closest(".phero__grid");
        var gallery = scope && scope.querySelector("[data-native-product-gallery]");
        if (variant && gallery && gallery.getAttribute("data-native-product-gallery") === form.getAttribute("data-native-product-form")) {
          var main = gallery.querySelector(".phero__stage img");
          if (main && variant.image_url) {
            main.removeAttribute("srcset");
            main.removeAttribute("sizes");
            main.setAttribute("src", variant.image_url);
            main.setAttribute("alt", variant.image_alt || "");
          }
          gallery.querySelectorAll(".pgallery__thumb").forEach(function (thumb) {
            var active = thumb.getAttribute("data-media-id") === String(variant.media_id);
            thumb.classList.toggle("is-active", active);
            thumb.setAttribute("aria-pressed", active ? "true" : "false");
          });
        }
        if (changeUrl) {
          var url = new URL(window.location.href);
          var productUrl = new URL(form.getAttribute("data-product-url"), url.origin);
          if (url.pathname === productUrl.pathname) {
            if (variant) url.searchParams.set("variant", variant.id);
            else url.searchParams.delete("variant");
            window.history.replaceState(window.history.state, "", url.href);
          }
        }
      }
      document.addEventListener("click", function (event) {
        var option = event.target.closest && event.target.closest("[data-native-product-form] [data-option-value]");
        if (!option) return;
        var form = option.closest("[data-native-product-form]");
        var group = option.closest(".pspec__group");
        if (!group) return;
        group.querySelectorAll("[data-option-value]").forEach(function (button) {
          button.classList.toggle("is-active", button === option);
          button.setAttribute("aria-pressed", button === option ? "true" : "false");
        });
        var label = group.querySelector("[data-spec-value]");
        if (label) label.textContent = option.getAttribute("data-option-value");
        update(form, true);
      });
      document.addEventListener("submit", function (event) {
        var form = event.target;
        if (!form.matches("[data-native-product-form]")) return;
        var variant = selectedVariant(form);
        var input = form.querySelector("[data-variant-id]");
        if (!variant || !variant.available || !input || input.value !== String(variant.id)) event.preventDefault();
      });
      function init() {
        document.querySelectorAll("[data-native-product-form]").forEach(function (form) { update(form, false); });
      }
      if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
      else init();
      document.addEventListener("shopify:section:load", init);
    })();

    /* Product hero spec selector — color / capacity / type selection */
    document.addEventListener("click", function (e) {
      var o = e.target.closest && e.target.closest(".pspec__opt");
      if (!o) return;
      if (o.closest("[data-native-product-form]")) return;
      var group = o.closest(".pspec__group");
      if (group) {
        group.querySelectorAll(".pspec__opt").forEach(function (b) { b.classList.remove("is-active"); });
        var label = group.querySelector("[data-spec-value]");
        if (label) label.textContent = o.getAttribute("data-name");
      }
      o.classList.add("is-active");
      var price = o.getAttribute("data-price");
      if (price) { var amt = document.querySelector(".phero__price .amt"); if (amt) amt.textContent = price; }
      var img = o.getAttribute("data-img");
      if (img) {
        var main = document.querySelector(".phero__stage img");
        if (main) main.setAttribute("src", img);
        document.querySelectorAll(".pgallery__thumb").forEach(function (t) {
          t.classList.toggle("is-active", t.getAttribute("data-full") === img);
        });
      }
    });
  

/* maktar-marquee-seamless: keep ribbon / announcement marquees looping with no gap.
   The CSS animates translateX(0 -> -50%), which is only seamless when one half of
   the track is wider than its container. Short content on wide screens leaves a gap
   at the loop point. Fix: duplicate the whole track (stays 2 identical halves) until
   half-width >= container width, so -50% always lands on identical content. */
(function () {
  function setup(track) {
    if (track.__mqOrig == null) track.__mqOrig = track.innerHTML;
    function fit() {
      var c = track.parentElement; if (!c) return;
      track.innerHTML = track.__mqOrig;
      if (getComputedStyle(track).animationName === 'none') return; // static (e.g. mobile)
      var guard = 0;
      while (track.scrollWidth / 2 < c.clientWidth + 2 && guard++ < 12) {
        track.innerHTML += track.innerHTML; // double -> still two identical halves
      }
    }
    fit();
    return fit;
  }
  function init() {
    var tracks = document.querySelectorAll('.ribbon__track, .maktar-announcement__track, [data-marquee-track]');
    if (!tracks.length) return;
    var fns = [];
    tracks.forEach(function (t) { fns.push(setup(t)); });
    var to;
    window.addEventListener('resize', function () {
      clearTimeout(to);
      to = setTimeout(function () { fns.forEach(function (f) { f(); }); }, 200);
    });
    // re-fit once fonts settle (text width can change after webfont load)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { fns.forEach(function (f) { f(); }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



/* moft scroller arrows: robust delegated handler (replaces PageFly-fragile inline onclick) */
(function(){
  Array.prototype.forEach.call(document.querySelectorAll('.moft__arrow[onclick]'), function(a){ a.removeAttribute('onclick'); });
  document.addEventListener('click', function(e){
    var a=e.target.closest ? e.target.closest('.moft__arrow') : null; if(!a) return;
    e.preventDefault();
    var wrap=a.closest('.wrap')||a.closest('section')||document;
    var strip=wrap.querySelector('.moft__strip'); if(!strip) return;
    var back=/back|prev|left/i.test(a.getAttribute('aria-label')||'');
    strip.scrollBy({left:(back?-1:1)*340, behavior:'smooth'});
  });
})();


/* Lineup swipe stack — vanilla port of Originkit's "Swipe Card Stack" (React/framer-motion
   source supplied by the owner), using the component defaults:
     tiltAngleStart 0 -> tiltAngle -45deg (normalized across the deck, around card center)
     xOffset 200         (total horizontal spread, normalized f = i/(n-1))
     y      -8px * i     (stackOffset, per depth step)
     scale   1 - 0.05*i  (per depth step)
     translateZ -10px*i under a 1000px perspective (DEPTH_SPACING / PERSPECTIVE)
     zIndex  n - i, tweened ~0.3s ease-out (flicked card stays on top while travelling)
     swipeThreshold 50   (TOTAL drag distance, sqrt(dx^2+dy^2), any direction)
     drag: rubber-banded to center (dragElastic 0.7, both axes); whileDrag scale 1.05,
           rotate tiltAngleStart, zIndex 1000
     flick: top card springs DIRECTLY to the back pose (no fly-off); short drags spring back
     spring: stiffness 300 / damping 30 -> approximated with back.out(1.2) @ ~0.55s
   No arrows / dots / autoplay — the component is drag-only. Cards here are links, so a
   clean tap (no drag) still navigates. */
(function () {
  var root = document.getElementById('lineupStack');
  var deck = document.getElementById('lineupStackDeck');
  if (!root || !deck) return;
  var cards = Array.prototype.slice.call(deck.querySelectorAll('[data-stack-card]'));
  if (!cards.length) return;
  var order = cards.slice(); // order[0] = front/top card
  // POLICY (diary 2026-07-17): these springs are direct feedback to the user's own
  // drag — NOT autonomous motion — so they run even under prefers-reduced-motion.
  // Windows reports "reduce" whenever Settings→Accessibility→Animation effects is
  // off (a common default), which made the whole component look dead on Windows.
  var reducedMotion = false;
  var hasGsap = !!window.gsap;
  var N = cards.length;

  // Component defaults (from the Originkit source)
  var TILT_START = 0, TILT_END = -45;
  var X_OFFSET = 200;       // total horizontal spread front -> back
  var STACK_OFFSET = 8;     // px upward per depth step
  var SCALE_STEP = 0.05;    // scale loss per depth step
  var DEPTH_SPACING = 10;   // translateZ px per depth step (perspective on .stack via CSS)
  var SWIPE_THRESHOLD = 50; // total drag distance that flicks the card
  var DRAG_ELASTIC = 0.7;   // rubber-band factor while dragging (constraints are 0,0,0,0)
  var SPRING = { duration: 0.55, ease: 'back.out(1.2)' }; // ~ spring(300, 30)

  function xEnd() {
    // faithful default is 200px; shrink only when the viewport can't fit the fan
    var rw = root.clientWidth || 520, cw = deck.clientWidth || 268;
    return Math.max(60, Math.min(X_OFFSET, rw - cw));
  }
  function centerFan() {
    // the fan extends right of the deck; offset the centered deck so the whole
    // composition (deck + spread) sits visually centered in the section
    deck.style.marginRight = xEnd() + 'px';
  }
  function pose(i) { // i = position in stack, 0 = front
    var f = N > 1 ? i / (N - 1) : 0;
    return {
      x: f * xEnd(),
      y: -STACK_OFFSET * i,
      rot: TILT_START + f * (TILT_END - TILT_START),
      scale: 1 - SCALE_STEP * i,
      zd: -DEPTH_SPACING * i,
      z: N - i
    };
  }
  function setNow(el, p) {
    if (hasGsap) { gsap.set(el, { x: p.x, y: p.y, z: p.zd, rotation: p.rot, scale: p.scale, zIndex: p.z }); }
    else {
      el.style.transform = 'translate3d(' + p.x + 'px,' + p.y + 'px,' + p.zd + 'px) rotate(' + p.rot + 'deg) scale(' + p.scale + ')';
      el.style.zIndex = p.z;
    }
  }
  function setAnimated(el, p) {
    if (hasGsap && !reducedMotion) {
      gsap.to(el, { x: p.x, y: p.y, rotation: p.rot, scale: p.scale, duration: SPRING.duration, ease: SPRING.ease });
      // z-depth and zIndex run on their own 0.3s ease-out, like the source's transition map
      gsap.to(el, { z: p.zd, zIndex: p.z, duration: 0.3, ease: 'power1.out', snap: { zIndex: 1 } });
    } else { setNow(el, p); }
  }
  function layout(animate) {
    order.forEach(function (card, i) {
      var p = pose(i);
      card.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      card.tabIndex = i === 0 ? 0 : -1;
      card.style.cursor = i === 0 ? 'grab' : 'default';
      if (animate) setAnimated(card, p);
      else setNow(card, p);
    });
  }
  centerFan();
  layout(false);

  // cards are <a> elements: block the browser's native link drag-and-drop, which
  // otherwise hijacks the pointer stream (pointercancel) a few px into a drag
  root.addEventListener('dragstart', function (e) { e.preventDefault(); });

  var dragging = false, active = null, sx = 0, sy = 0, dx = 0, dy = 0, moved = false;
  root.addEventListener('pointerdown', function (e) {
    var card = e.target.closest('[data-stack-card]');
    if (!card || order[0] !== card) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return; // left button only
    dragging = true; moved = false; sx = e.clientX; sy = e.clientY; dx = 0; dy = 0; active = card;
    if (card.setPointerCapture) { try { card.setPointerCapture(e.pointerId); } catch (err) {} }
    card.style.cursor = 'grabbing';
    if (hasGsap) {
      gsap.killTweensOf(card);
      // whileDrag: scale 1.05, rotate tiltAngleStart, zIndex 1000
      card.style.zIndex = 1000;
      gsap.to(card, { scale: 1.05, rotation: TILT_START, duration: 0.2, ease: 'power2.out' });
    }
  });
  root.addEventListener('pointermove', function (e) {
    if (!dragging || !active) return;
    dx = e.clientX - sx;
    dy = e.clientY - sy;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
    // constraints are {0,0,0,0} + dragElastic 0.7 -> card moves at 70% of the pointer offset
    var ex = dx * DRAG_ELASTIC, ey = dy * DRAG_ELASTIC;
    if (hasGsap) gsap.set(active, { x: ex, y: ey });
    else active.style.transform = 'translate(' + ex + 'px,' + ey + 'px) scale(1.05)';
  });
  function endDrag() {
    if (!dragging || !active) return;
    dragging = false;
    var card = active; active = null;
    card.style.cursor = 'grab';
    var distance = Math.sqrt(dx * dx + dy * dy); // source uses TOTAL offset distance
    if (distance > SWIPE_THRESHOLD) {
      // flick: move the top card to the back of the stack; every card springs to its
      // new pose (the flicked one travels from wherever it was dropped — no fly-off)
      order.push(order.shift());
      layout(true);
    } else if (hasGsap && !reducedMotion) {
      // short drag: spring back to the front pose (scale returns from whileDrag 1.05)
      var p0 = pose(0);
      gsap.to(card, { x: p0.x, y: p0.y, rotation: p0.rot, scale: p0.scale, duration: SPRING.duration, ease: SPRING.ease });
      gsap.to(card, { z: p0.zd, zIndex: p0.z, duration: 0.3, ease: 'power1.out', snap: { zIndex: 1 } });
    } else { setNow(card, pose(0)); }
    dx = 0; dy = 0;
  }
  root.addEventListener('pointerup', endDrag);
  root.addEventListener('pointercancel', endDrag);

  // cards are links: block navigation when the pointer actually dragged
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); return; }
      if (order[0] !== card) e.preventDefault(); // back cards aren't clickable targets in the source
    });
  });

  var rto;
  window.addEventListener('resize', function () {
    clearTimeout(rto);
    rto = setTimeout(function () { centerFan(); layout(false); }, 150);
  });
})();
